import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { I18NextPipe } from 'angular-i18next';
import { report } from 'src/app/dashboards/models';
import { deepCheckObject, periodIsDayOrMonth } from 'src/app/dashboards/widget/widget-helpers/helpers';
import { widgetType } from 'src/app/enums';
import { gridItem, interaction, rule } from 'src/app/models';
import { DashboardService } from 'src/app/services/services/dashboard.service';

@Component({
    selector: 'app-base-web-engage-reports-settings',
    templateUrl: './base-web-engage-reports-settings.component.html',
    styleUrls: ['./base-web-engage-reports-settings.component.scss'],
    standalone: false
})

export class BaseWebEngageReportsSettingsComponent implements OnInit {
  @Input() public gridItem: gridItem;
  @Input() public report: report | any;
  @Output() public gridItemSetupChangedNotifier = new EventEmitter<boolean>();

  initialSetup: any;
  initialGridItemType: widgetType;
  sysGroupByTime: any[] = [];
  ruleItems: rule[] = [];
  interactionItems: interaction[] = [];
  visualTypeDisabledItems: number[] = [3];
  disabledColumns: any[] = [];

  constructor(protected dashboardsService: DashboardService, protected i18nextPipe: I18NextPipe) { }

  ngOnInit(): void {
    // set fixed sysGroupByTime because we not supposed to get it from back-end
    this.sysGroupByTime = [
      { key: " ", value: "(no grouping)" },
      { key: "F", value: "5 Minutes" },
      { key: "Q", value: "Quarter" },
      { key: "H", value: "Hour" },
      { key: "D", value: "Day" },
      { key: "M", value: "Month" }
    ];
  }

  loadRulesAndInteractions(from, to, removeNotFoundItems = true) {
    let setup = this.gridItem.setup;
    this.dashboardsService.getRuleList(from, to).subscribe(rules => {
      this.ruleItems =  [...new Map(rules.map(item => [item.ruleId, item])).values()];
      this.ruleItems.sort((a, b) => a.ruleName.localeCompare(b.ruleName));

      let ruleIds = rules.map(r => r.ruleId);
      if(removeNotFoundItems){
      setup.ruleIds = setup.ruleIds?.filter(x => ruleIds.includes(x)) ?? [];
      }
      this.loadInteractions([], from, to,removeNotFoundItems);
    });
  }

  loadInteractions(ruleIds: string[], from, to, removeNotFoundItems = true) {
    let setup = this.gridItem.setup;
    this.dashboardsService.getInteractionList(from, to).subscribe(interactions => {
      if (ruleIds && ruleIds.length > 0) {
        this.interactionItems = interactions.filter(i => ruleIds.indexOf(i.ruleId) > -1);
      } else {
        this.interactionItems = interactions;
      }
      this.interactionItems =  [...new Map(this.interactionItems.map(item => [item.interactionId, item])).values()];
      this.interactionItems.sort((a, b) => a.interactionName.localeCompare(b.interactionName));
      if(removeNotFoundItems){
      setup.interactionIds = setup.interactionIds?.filter(x => this.interactionItems.map(r => r.interactionId).includes(x)) ?? [];
      }
    });
  }

  visualTypeCheck() {
    let setup = this.gridItem.setup;
    let isOneDimension = setup.interactionIds?.length == 1 && setup.ruleIds?.length == 1 && !setup.excludeRules && !setup.excludeInteractions;
    if (isOneDimension || setup.sysGroupByTime == " ") {
      this.visualTypeDisabledItems = [3];
    } else {
      this.visualTypeDisabledItems = [0, 1, 2, 3];
      if (this.gridItem.type != widgetType.Table) {
        this.gridItem.type = null;
      }
    }
  }

  notifyReportModified() {
    this.gridItemSetupChangedNotifier.emit();
  }

  interactionsModelChanged(selectedItemIds) {
    this.gridItem.setup.interactionIds = selectedItemIds;
    this.visualTypeCheck();
    this.notifyReportModified();
  }

  columnsModelChange(columns) {
    let init = this.gridItem.setup.columns;
    this.gridItem.setup.columns = columns;

    if (!deepCheckObject(init, columns)) {
      this.notifyReportModified();
    }
  }

  setDisabledColumns(from,to) {
    if (periodIsDayOrMonth(from, to) || this.gridItem.setup.sysGroupByTime != " ") {
      this.disabledColumns = [];
    } else {
      this.disabledColumns = ["u_count"];
      this.gridItem.setup.columns = this.gridItem.setup.columns.filter(col => !this.disabledColumns.includes(col));
    }
  }
}
